import { MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import ImageUploading from 'react-images-uploading';

export default function ImageUploader({ myimagelist, setMyimagelist }) {
  const maxNumber = 69;
  const onChange = (imageList, addUpdateIndex) => {
    // data for submit

    setMyimagelist(imageList)
  };

  return (
    <div className="App" >
      <ImageUploading
        multiple
        value={myimagelist}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageRemove,
          isDragging,
          dragProps
        }) => (
          // write your building UI
          <div className="upload__image-wrapper">
            <div className="stopwatch" >
              <span style={{ width: "60%" }}>

                <h6>Add images for this section ?</h6>
                <button
                  style={isDragging ? { background: "green", color: 'white' } : null}
                  onClick={onImageUpload}
                  {...dragProps}
                  className="stopwatch-btn stopwatch-btn-gre"
                >
                  Click or Drop here
                </button>
                &nbsp;
                <button className="stopwatch-btn stopwatch-btn-red" onClick={onImageRemoveAll}>Remove all images</button>
                <br /><br />
              </span></div>
            <br />
            <div className="stopwatch">
              <span style={{ width: "60%" }}>
                {imageList.map((image, index) => (
                  <div key={index} className="image-item" style={{ margin: 10, border: "1px solid #00008b4f", background: 'white', borderRadius: 5 }}>
                    <div style={{ width: '50%', float: 'left' }}>
                      <img style={{ margin: 10, height: '150px', maxHeight: 180, maxWidth: 'auto' }} src={image.data_url} alt="" />
                    </div>

                    <div style={{ width: "50%", float: 'right' }}>
                      <TextField
                        inputProps={{
                          maxLength: 386,
                        }}
                        id="outlined-multiline-flexible"
                        label="Title"
                        multiline
                        maxRows={1}
                        value={myimagelist[index][1]}
                        style={{ width: '90%', margin: 10 }}
                        // defaultValue={"Schema "+(index+1)}
                        onChange={(e) => {
                          myimagelist[index][1] = e.target.value
                          setMyimagelist(imageList => [...imageList]);
                        }}
                      /><br />
                      <TextField
                        inputProps={{
                          maxLength: 386,
                        }}
                        id="outlined-multiline-flexible"
                        label="Image Name"
                        maxRows={1}
                        value={image.file.name}
                        disabled
                        style={{ width: '90%', margin: 10 }}
                      // defaultValue={"Schema "+(index+1)}
                      /><br />
                      <TextField
                        inputProps={{
                          maxLength: 386,
                        }}
                        id="outlined-multiline-flexible"
                        label="Description  (optional)"
                        multiline
                        maxRows={4}
                        style={{ width: '90%', margin: 10, height: '90%' }}
                        value={myimagelist[index][2]}
                        onChange={(e) => {
                          myimagelist[index][2] = e.target.value
                          setMyimagelist(imageList => [...imageList]);
                        }}
                      />
                    </div>

                    <div className="stopwatch" >
                      <span style={{ width: "150px" }}>
                        <button className="stopwatch-btn stopwatch-btn-red" onClick={() => onImageRemove(index)}>Remove</button>
                      </span></div>
                    <br />
                  </div>
                ))}</span></div>
          </div>
        )}
      </ImageUploading>
    </div>
  );
}